module.exports = __webpack_public_path__ + "static/media/product-pic.8e8cc375.jpg";